var exports = {
  "kL": "container__J3e2-Z",
  "D2": "buttonStack__1YyfAl",
  "r0": "threadInfoStack__jpNBcA",
  "D3": "threadTitle__xBTdN2",
  "nB": "threadDescription__y8qOm3",
};

module.exports = exports;
